import React from "react";
import "./Why_Partner_with_Us.css";

function Why_Partner_with_Us() {
  return (
    <>
      <section className="Why_Partner_with_Us">
        <div className="container">
          <div className="heading_vdo_holder">
            <div className="heading_vdo">
              <video
                className="vdo"
                src={process.env.PUBLIC_URL + "/Assets/Vedio/Home/reachout.mp4"}
                autoPlay
                loop
                muted
              />
            </div>

            <div className="heading_holder">
            <h1 className=" heading">Why Partner with Us?</h1>
          </div>
          </div>
         
          <div className="row justify-content-center">
            <div className="col-xl-8 col-md-10">
              <div className="content-holder">
                <div className="row justify-content-between">
                  <div className="col-lg-6 col-md-6 col-sm-6">
                    <div className="text-holder">
                      <h4>Unmatched Reach</h4>
                      <p>
                        With a wide network of digital screens and print media
                        partnerships across both urban and rural areas, we help
                        you connect with a broader audience, including hard-to
                        reach areas
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-6">
                    <div className="text-holder">
                      <h4>Tailored Advertising Solutions</h4>
                      <p>
                        We offer flexible and customizable advertising packages
                        that are designed to meet your specific needs. No matter
                        your industry or budget, we have a solution that fits.
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-6">
                    <div className="text-holder">
                      <h4>Data-Driven Success</h4>
                      <p>
                        We track every aspect of your campaign, from engagement
                        rates to audience demographics, ensuring that your ads
                        perform at their best. Our detailed analytics help you
                        make informed decisions for even better results.
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-6">
                    <div className="text-holder">
                      <h4>End-to-End Service</h4>
                      <p>
                        From strategy development to ad creation and campaign
                        execution, we handle everything. Our team works closely
                        with you to ensure your brand’s message is consistent,
                        creative, and impactful.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Why_Partner_with_Us;
